import React, { PureComponent } from "react";

export default class HeaderIcon extends PureComponent {
  state = {};

  render() {
    return (
      <div
        onMouseEnter={() => this.setState({ wink: true })}
        onMouseLeave={() => this.setState({ wink: false })}
        style={{ padding: 0, marginLeft: "1em" }}
      >
        <Logo wink={this.state.wink} />
      </div>
    );
  }
}

const Logo = ({ wink }) => (
  <svg className="patreon" style={{ width: "4em", height: "4em" }}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="18 47 90 90">
      {!wink ? (
        <path
          fill="#fff"
          d="M47.55 96.65c0-2.26-.78-4.02-2.63-4.78a4.28 4.28 0 0 0-3.3.03c-1.85.79-2.7 2.47-2.7 4.75v.08c0 2.27.78 4.02 2.63 4.79 1.05.44 2.26.41 3.3-.03 1.85-.8 2.7-2.48 2.7-4.76v-.04-.04M63.02 96.65c0-2.26.78-4.02 2.63-4.78a4.28 4.28 0 0 1 3.3.03c1.85.79 2.7 2.47 2.7 4.75v.08c0 2.27-.78 4.02-2.63 4.79a4.29 4.29 0 0 1-3.3-.03c-1.86-.8-2.7-2.48-2.7-4.76v-.04-.04"
        />
      ) : (
        <path
          fill="#fff"
          d="M47.55 96.65c0-2.26-.78-4.02-2.63-4.78a4.28 4.28 0 0 0-3.3.03c-1.85.79-2.7 2.47-2.7 4.75v.08c0 2.27.78 4.02 2.63 4.79 1.05.44 2.26.41 3.3-.03 1.85-.8 2.7-2.48 2.7-4.76v-.04-.04M73.36 96a8.38 8.38 0 0 0-3.24-2.1 9.31 9.31 0 0 0-5.48-.04 7.8 7.8 0 0 0-3.28 2.2 2.34 2.34 0 0 0 .26 3.33c1 .85 2.48.73 3.33-.26.1-.13.64-.63 1.1-.77.8-.25 1.8-.24 2.63.02.48.16 1.04.63 1.22.82a2.34 2.34 0 0 0 3.33.13 2.36 2.36 0 0 0 .13-3.33"
        />
      )}
      <path
        fill="#fff"
        d="M55.28 62.4c-20.9.15-32.7 15.54-32.7 32.54 0 16.98 12.42 29.17 32.7 29.3 20.3-.13 32.7-12.32 32.7-29.3 0-2.45-.24-4.87-.72-7.2 1.77.22 3.71.23 5.67-.23 6.6-1.55 10.8-7.83 10.8-7.83s-5.28-3.03-11.14-2.52c4.6-4.37 5.5-11.13 5.5-11.13s-7.53-.5-12.78 3.81a16.06 16.06 0 0 0-3.88 4.84c-5.52-7.3-14.4-12.2-26.15-12.28zm0 20.56c11.66.01 22.67 3.1 23.87 11.98.81 5.98-3.23 15.6-19 11.83-3.2-.77-6.55-.77-9.76-.03-15.71 3.65-19.78-5.82-18.97-11.8 1.2-8.89 12.21-11.97 23.86-11.98z"
      />
      <path
        fill="#717171"
        d="M58.23 62.53v6.52h7.97v-5a36 36 0 0 0-7.97-1.52zm7.97 6.52v7.97h7.98v-7.97H66.2zm7.98 0h1.68c-.55-.42-1.1-.82-1.68-1.2v1.2zm0 7.97V85h7.97v-7.98h-7.97zm7.97 0h7.97v-7.97h-3.74a15.31 15.31 0 0 0-4.23 4.4v3.57zm7.97-7.97h7.25c.55-1.77.72-3.02.72-3.02s-3.85-.25-7.97 1.18v1.84zm0 7.97V85h7.98v-7.4c-1.66-.38-3.55-.61-5.51-.44l.13-.14h-2.6zM98.1 85v.19l.27-.2h-.27zm-7.98 0h-7.97v7.97h5.78c-.1-1.77-.32-3.53-.67-5.24.91.12 1.88.18 2.86.15V85zm-7.97 7.97H78.7a11.71 11.71 0 0 1-.36 7.97h3.8v-7.97zm0 7.98v7.97h2.5a27.9 27.9 0 0 0 2.78-7.97h-5.28zm0 7.97h-7.97v7.97h3.93a26.6 26.6 0 0 0 4.04-4.12v-3.85zm-7.97 7.97H66.2v5.95a33.12 33.12 0 0 0 7.98-3.24v-2.7zm-7.98 0v-7.97h-7.97v7.97h7.97zm-7.97 0h-7.98v7.05c1.62.18 3.3.28 5.03.3 1-.01 1.99-.05 2.95-.11v-7.24zm-7.98 0v-7.97h-7.97v7.97h7.97zm-7.97 0H34.3v1.4a31.3 31.3 0 0 0 7.98 3.93v-5.33zm-7.98 0v-7.97h-7.97v.75a26.36 26.36 0 0 0 6.13 7.22h1.84zm-7.97-7.97v-7.97h-3.2a27.9 27.9 0 0 0 2.78 7.97h.42zm0-7.97h5.92a11.56 11.56 0 0 1-.38-7.98h-5.54v7.98zm0-7.98V85H24a35.06 35.06 0 0 0-1.35 7.97h3.7zm0-7.97h7.97v-7.98h-6.77c-.42.7-.82 1.4-1.2 2.12V85zm7.97-7.98h7.98v-7.97h-7.57l-.4.32v7.65zm7.98-7.97h7.97v-6.3a34.41 34.41 0 0 0-7.97 2.03v4.27zm7.97 0v7.97h7.98v-7.97h-7.98zm7.98 7.97v6.01c2.78.13 5.48.46 7.97 1.03v-7.04h-7.97zm-7.98 0h-7.97v7.58a40.36 40.36 0 0 1 7.97-1.43v-6.15zM34.3 85v4.02c1.7-1.75 4.01-3.07 6.74-4.02H34.3zm0 23.92h7.98v-1.43c-3.66-.31-6.24-1.64-7.98-3.44v4.87zm15.95 0h7.98v-2.52c-2.6-.37-5.27-.26-7.84.34l-.14.03v2.15zm15.95 0h7.98v-3.14c-1.97 1.2-4.58 1.91-7.98 1.83v1.31zM74.18 85h-4.65c1.73.6 3.3 1.35 4.65 2.27V85z"
      />
    </svg>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/HeaderIcon.js